export default __webpack_public_path__ + "static/media/Logo dictionary plusplus 2.4ea9fa9e.png";